import { PageRoutes } from '../features/app/pages/domain/constants/PageRoutes';
import { AirportCodes } from '../types/airports';

export const getHomePageUrl = (airportCode?: string) => {
	switch (airportCode) {
		case AirportCodes.IAH:
			return PageRoutes.IAHHome;
		case AirportCodes.HOU:
			return PageRoutes.HOUHome;
		case AirportCodes.EFD:
			return PageRoutes.EFDHome;
		case AirportCodes.Spaceport:
			return PageRoutes.SpaceportHome;
		case AirportCodes.Corporate:
			return PageRoutes.CorporateHome;
		default:
			return PageRoutes.Gateway;
	}
};
